<template>
    <button @click="buttonAction()"
            @touch="buttonAction()" 
            ref="buttonGame" 
            class="button-default"
            :class="`${classInitial}-button`"
            classInitial
            :style="defineStyle"
            >
            <p>
                <span v-if="loaderButton">
                    <loader-button v-if="name == 'schedule' || name == 'suggestion'"></loader-button>
                </span>
                <span v-else>{{ textButton }}</span>
            </p>
            <!-- <img v-if="name == 'schedule'" src="../../assets/arrow-down.png" class="arrow-down"> -->
    </button>
</template>
<script>
import LoaderButton from '../Loaders/LoaderButton.vue'
import {addAlpha} from '../../helpers/custom.js'
export default {
    components : {
        LoaderButton
    },
    props: {
        textButton : {
            type : String,
            required : true
        },
        classButton : {
            type : String
        },
        name : {
            type : String
        },
        statusButton : {
            type : String
        },
        buttonLoader : {
            type : Boolean
        },
        loaderButton : {
            type : Boolean
        },
        buttonType: {
            type : String
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    data(){
        return{
            colors:{}
        }
    },
    computed: {
        classInitial() {
            let classButton = this.classButton
            let buttonGame = this.$refs.buttonGame
            if(classButton){
                return classButton
            }

            return ''
        },
        defineStyle(){
            // if(this.theme == 'dark')
            let color = ''
            let backgroundColor = this.classInitial == 'disabled' || this.classInitial == 'expired' ? '#bfbfbf' : this.colors.secondary
            let boxShadowColor = this.classInitial == 'disabled' || this.classInitial == 'expired' ? '0px 5px 0px 0px' + addAlpha('#5e5e5e', 0.5) : '0px 5px 0px 0px' + addAlpha(this.colors.secondary, 0.5)
            if(this.classInitial == 'finished' || this.classInitial == 'scheduled-game') backgroundColor = addAlpha("#000000", 0.2)
            if(this.classInitial == 'started-game') {
                backgroundColor = '#fff'
                color = this.colors.secondary
            }
            if(this.buttonType == 'sugestion' || this.buttonType == 'send-sugestion') {
                color = this.colors.theme == 'dark' ? '#fff' : '#fff'
                backgroundColor = this.colors.theme == 'dark' ? '#000' : '#000'
                boxShadowColor = this.colors.theme == 'dark' ? '#9fa2a7 0px 5px 0px 0px' : '#9fa2a7 0px 5px 0px 0px'
            }
            if(this.buttonType == 'back-to-enigmas' || this.buttonType == 'team-finish') {
                color = this.colors.theme == 'dark' ? '#000' : '#000'
                backgroundColor = this.colors.theme == 'dark' ? '#fff' : '#fff'
                boxShadowColor = this.colors.theme == 'dark' ? '#9fa2a7 0px 5px 0px 0px' : '#9fa2a7 0px 5px 0px 0px'
            }
            return {
                'box-shadow': boxShadowColor,
                'background-color': backgroundColor,
                'color': color
            }
        },
        
    },
    methods: {
        buttonAction(){
            if(this.loader){
                return
            }
            if(this.classButton){
                this.action(`action-start-${this.classButton}`, `action-end-${this.classButton}`)
            }else{
                this.action(`action-start-button`, `action-end-button`)
            }
        },
        action(start, end){
            let buttonGame = this.$refs.buttonGame
            buttonGame.classList.add(start)
            setTimeout(function(){ 
                buttonGame.classList.remove(start)
                buttonGame.classList.add(end) 
            }, 200);
            buttonGame.classList.remove(end)
        }
    }
    
}
</script>
<style lang="scss" scoped>

    .button-default{
        padding: 23px 0px;
        border-radius: 30px;
        // background-color: #FFF581;
        display: flex;
        align-items: center;
        width: 100%;
        border: none;
        height: 45px;
        max-height: 45px;
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: bold;
        // font-size: 9px;
        // border-top: 6px #FFF581 solid;
        // border-bottom: 6px #FFC483 solid;
        outline: none;
        vertical-align: middle;
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        position: relative;
        color: #fff;

        p{
            // margin-bottom: 3px;
            font-size: 15px;
            letter-spacing: 2px;
            font-weight: 900;

        }

        .arrow-down{

            height: 8px;
            position: absolute;
            right: 10%;
            bottom: 45%;
        }
    }

    .action-start-scheduled, .action-start-open{

        // border-top: 6px #EFEFEF solid;
        // border-bottom: 6px #FFF581 solid;
        -webkit-box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);
        -moz-box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);
        box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);

        // p{
        //     margin-top: 0px;

        // }

        .arrow-down{

            bottom: 30%;
        }
    }

    .scheduled-button, .dash-open-button{
        z-index : 1001;
        color: #fff;

    }

    .action-start-game{
        // border-top: 6px #cffbfa solid;
        // border-bottom : 6px #FFF581 solid;

        // p{
        //     margin-top: 7px;
        // }
    }

    .scheduled-button{
        // background-color: #8A00C4;
        // border-top: 6px solid #8A00C4;
        // border-bottom: 6px solid #600093;
        // color: white;
    }

    .action-start-scheduled{

        // border-top: 6px #e7fffd solid;
    }

    .action-start-button{
        // border-top: 6px #e7fffd solid;
        // border-bottom: 6px #8a00c4 solid;
        -webkit-box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);
        -moz-box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);
        box-shadow: 0px 4px 5px 0px rgba(134, 133, 133, 0.41);

        // p{
        //     margin-top: 7px;

        // }

        .arrow-down{

            bottom: 30%;
        }
    }

    .action-end-button .action-end-scheduled{
        // border-top: 6px #8a00c4 solid;
        // border-bottom: 6px #600093 solid;
        -webkit-box-shadow: 0px 0px 0px 0px rgba(134, 133, 133, 0.41);
        -moz-box-shadow: 0px 0px 0px 0px rgba(134, 133, 133, 0.41);
        box-shadow: 0px 0px 0px 0px rgba(134, 133, 133, 0.41);
    }

    .team-finish-button{

        -webkit-box-shadow: 0px 6px 5px 0px #262a2f;
        -moz-box-shadow: 0px 6px 5px 0px #262a2f;
        box-shadow: 0px 6px 5px 0px #262a2f;
    }

    .action-start-team-finish{
        // border-top: 6px #30353b solid;
        // border-bottom: 6px #FFF581 solid;
        box-shadow: none;

        // p{
        //     margin-top: 10px;
        // }
    }

    .action-end-team-finish{

    }

    .disabled-button{

        background-color: #cecece;
        color: white;
        height: 45px;
        max-height: 45px;
        // border-top: 6px #cecece solid;
        // border-bottom: 6px #bababa solid;
        -webkit-box-shadow: 0px 6px 5px 0px #d7d7d7;
        -moz-box-shadow: 0px 6px 5px 0px #d7d7d7;
        box-shadow: 0px 6px 5px 0px #d7d7d7;
    }

    .finished-button, .expired-button{

        background-color: #5e5e5e;
        color: white;
        height: 45px;
        max-height: 45px;
        // border-top: 6px #5e5e5e solid;
        // border-bottom: 6px #474747 solid;
        -webkit-box-shadow: 0px 6px 5px 0px #6b6b6b;
        -moz-box-shadow: 0px 6px 5px 0px #6b6b6b;
        box-shadow: 0px 6px 5px 0px #6b6b6b;
    }

    .finished-button{

        -webkit-box-shadow: 0px 6px 5px 0px #cbcbcb;
        -moz-box-shadow: 0px 6px 5px 0px #cbcbcb;
        box-shadow: 0px 6px 5px 0px #cbcbcb;
    }

    .final-equation-button{
        -webkit-box-shadow: 0px 6px 5px 0px #252a2e;
        -moz-box-shadow: 0px 6px 5px 0px #252a2e;
        box-shadow: 0px 6px 5px 0px #252a2e;
        
    }

    .action-start-final-equation{
        // border-top: 6px #2f353a solid;
        // border-bottom: 6px #FFF581 solid;
        box-shadow: none;

        // p{
        //     margin-top: 10px;
        // }
    }

    .action-end-final-equation{
        // border-top: 6px #FFF581 solid;
        // border-bottom: 6px #FFC483 solid;
        box-shadow: none;
        -webkit-box-shadow: 0px 6px 5px 0px #252a2e;
        -moz-box-shadow: 0px 6px 5px 0px #252a2e;
        box-shadow: 0px 6px 5px 0px #252a2e;

        // p{
        //     // margin-bottom: 5px;
        //     font-size: 10px;
        // }
    }

    .dash-open-button{

        // background-color: #FFF581;
        color: #fff ;
        font-size: 15px;
        height: 45px;
        max-height: 45px;
        // border-top: 6px #FFF581 solid;
        // border-bottom: 6px #FFC483 solid;
        box-shadow: 0px 5px 0px 0px rgba(0,0,0,0.10);
        

        p{
            font-weight: 900;
            // margin-bottom: 5px;
            font-size: 15px;
        }
        
    }

    .scheduled-game-button{
        color: #b7b7b6;
        // background-color: #3defe4;
        // border-top-color: #3defe4;
        // border-bottom-color: #36d5c6;
        box-shadow: 0px 5px 0px 0px rgba(0,0,0,0.10);
    }

    .scheduled-expired-button{
        color: #fff ;
        z-index: 1001;
    }

    .action-start-dash-open, .action-start-scheduled-expired{ //botão de agenda, açao ao clicar

        // border-top: 6px rgba(255, 255, 255, 0) solid;
        // border-bottom: 6px #FFF581 solid;
        // box-shadow: none !important;

        // p{
        //     margin-top: 10px;
        // }

        .arrow-down{

            bottom: 30%;
        }
    }

    .action-end-dash-open, .end-start-scheduled-expired{

        border-top: 6px transparent solid;
        // border-bottom: 6px #FFC483 solid;
        box-shadow: none;
        -webkit-box-shadow: 0px 0px 0px 0px #a1a1a144;
        -moz-box-shadow: 0px 0px 0px 0px #a1a1a144;
        box-shadow: 0px 0px 0px 0px #a1a1a144;

        p{
            // margin-bottom: 5px;
        }
    }

    .started-game-button, .in-progress{
        color: #2F353A ;
    }

    

</style>
